import { animate, keyframes, style, transition, trigger } from '@angular/animations';
import { Component, Output, EventEmitter, OnInit, HostListener, ElementRef, ViewChild,OnDestroy } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import { MatDialog, MatDialogConfig } from '@angular/material/dialog';
import { CookieService } from 'ngx-cookie-service';
import { AuthenticationService } from 'src/app/shared/services/auth/authentication.service';
import { NotificationService } from './../../../shared/services/notification.service';
import { LocalDataService } from './../../../shared/services/local-data.service';
import { CommonService } from './../../../shared/services/common.service';
import { Constants } from './../../../shared/constants';
import { ChangePasswordComponent } from 'src/app/components/login/change-password/change-password.component';
import { ElevatorCallService } from 'src/app/shared/services/elevator-call.service';
import { AboutComponent } from './about/about.component';
import { fadeInOut, INavbarData } from '../../../shared/helpers/helper';
import { CallElevatorComponent } from './../../../shared/components/call-elevator/call-elevator.component';
import { PhoneNumberSearchComponent } from './phone-number-search/phone-number-search.component';
//import { TranslationService } from '@transifex/angular';
import { FormControl, Validators } from '@angular/forms';
import { filter, map} from 'rxjs/operators';
import { EndOfAlarmComponent } from 'src/app/components/common/end-of-alarm/end-of-alarm.component';
import { environment } from 'src/app/environments/environment';
import { UserProfileComponent } from '../../login/user-profile/user-profile.component';
import { RolePageActionHasPermissions } from './../../../shared/roleHasPermissions';
import { TwilioHelperService } from 'src/app/shared/services/twilio-helpers.service';
import { LocalizationService } from 'src/app/shared/localization/localization.service';
import { ScreenPopService } from '../../screenpop/screenpop.service';
import { HttpClient } from '@angular/common/http';
import { Subject,takeUntil } from 'rxjs';

interface SideNavToggle {
  screenWidth: number;
  collapsed: boolean;
}

@Component({
  selector: 'app-sidemenu',
  templateUrl: './sidemenu.component.html',
  styleUrls: ['./sidemenu.component.scss'],
  animations: [
    fadeInOut,
    trigger('rotate', [
      transition(':enter', [
        animate('1000ms',
          keyframes([
            style({ transform: 'rotate(0deg)', offset: '0' }),
            style({ transform: 'rotate(2turn)', offset: '1' })
          ])
        )
      ])
    ])
  ]
})
export class SidemenuComponent implements OnInit,OnDestroy {

  selectedCountry: any = this._localDataService.getLoginUserCountryId();
  selectedLanguage: any = this._localDataService.getLanguageShortName();
  selectedScreen: any = '';
  countries: any[] = this._localDataService.getSelectedCountriesByDisplay();
  languages: any[] = this._localDataService.getSelectedLanguages(Number.parseInt(this.selectedCountry));
  @Output() onToggleSideNav: EventEmitter<SideNavToggle> = new EventEmitter();
  collapsed = false;
  screenWidth = 0;
  navData = this._localDataService.getMenuList();
  multiple: boolean = false;
  hideme = false;
  isChecked = false;
  expanded = true;
  statusTranslation:any;
  callElevatorButtonEnable = false;
  phoneNumberButtonEnable = false;
  endOfAlarmButtonEnable = false;
  @ViewChild('phonenumbersearchmap', { static: true })
  twilioRingtone = { static: true };
  public mapContainer!: ElementRef;
  phoneNumber: string = '';
  elevatorId: string = '';
  eoaElevatorId = new FormControl('', Validators.required);
  rolePagePermission: any;
  userStatus  = Constants.USER_CURRENT_STATUS;
  //userStatus  = Constants.USER_CURRENT_STATUS.filter(m=> m.activityId !== 0);
  loggedUserRoleId = 0;
  selectedAgentStatus: any = {
    selectedStatus: undefined,
    prevSelStatus: undefined,
    onCallbackStatus: undefined
  };
  agentStatusCount: any= { available: 0, notAvailable: 0, offline: 0, inCall: 0, repeatedTPACallAlerts: 0 }
  userStatusDisplay =  true;
  public ringtone!: ElementRef;
  incomingCallStatus = { status: false, count: 0 };
  userType: any;
  roleUserArray = ['3','4','5','6','7', "/join-room"];
  destroy$ = new Subject<void>();
  statusjsondata: any;
  url:any;

  @HostListener('window:resize', ['$event'])
  onResize(event: any) {
    this.screenWidth = window.innerWidth;
    if (this.screenWidth <= 768) {
      this.collapsed = false;
      this.onToggleSideNav.emit({ collapsed: this.collapsed, screenWidth: this.screenWidth });
    }
  }

  constructor(public _router: Router, 
    public _localDataService: LocalDataService, 
    private _cookieService: CookieService,
    private authenticationService: AuthenticationService,
    public _twilioHelperService: TwilioHelperService,
    public _localizationService: LocalizationService,
    private _commonService: CommonService, public _dialog: MatDialog, private _notificationService: NotificationService,
    private readonly elevatorCallService: ElevatorCallService,private localCookies: CookieService,
    private _screenpopService: ScreenPopService,
    //private http: HttpClient
    ) {
    this.isChecked = true;
    
    //_localDataService.selectedScreen = ['dashboard','menu','status'];
   //_localizationService.use(this._localDataService.selectedCountry + '_' + this._localDataService.selectedLanguage, [...Constants.Localization.commonAreas, ..._localDataService.selectedScreen]);
    this.rolePagePermission = RolePageActionHasPermissions.roleAccessMenu(this._localDataService.getLoginUserRoleId().toString(), 'topbar');
    // Login User Type - CCC or Avaya
    this.userType = this._localDataService.isCCCLoginUser();
    // translationService.init({
    //   token: environment.txToken,
    // });

    this._router.events
    .pipe(filter((rs): rs is NavigationEnd => rs instanceof NavigationEnd))
    .subscribe(event => {
      if (
        event.id === 1 &&
        event.url === event.urlAfterRedirects
      ) {
        if (this._router.url !== "/join-room" && this._router.url != "/otislinepbx") {
          let payload:any={};
          payload.userId=this._cookieService.get(Constants.APPCOOKIES.CCC_USERID);
          payload.roleId=this._cookieService.get(Constants.APPCOOKIES.CCC_ROLEID);
          payload.loggedType='';
          this.authenticationService.genRefreshToken(payload).subscribe({
            next: (result: any) => {
                if (result?.body?.status) {
                    // Pass in some data in the `next()` function. 
                    // Every time this is called, your components subscription function will be triggered.
                    //this.dataStream.next(result.body.data);
                    //this._twilioHelperService.userLoginCookiesSet(result.body.data);
                    this._localDataService.setLoginUserData(result.body.data);
                    this._localDataService.localstorageSet('loginData', JSON.stringify(result.body.data))
                  ////localStorage.setItem('loginData', JSON.stringify(result.body.data));
                  if (this._localDataService.isAvayaUser())
                    this._commonService.userLoginCookiesSet(result.body.data);
                  else
                    this._twilioHelperService.leaveRoomIfJoined(null, true);
                    this._twilioHelperService.userLoginCookiesSet(result.body.data);
                  /*role base url access logic
                  * delimiter will be use for elevator call and phone number search
                  */
                  this._localDataService.roleBaseUrlAccess(result.body.data);
                  this.pageReloadData();
                }
            },
            error: (err: any) => {
                this._commonService.logException(err);
            }
          });
        }
      }
    })
  }
  searchByPhone() {
    if (this.phoneNumber.trim() == '') {
      this._notificationService.basicMessage('Please enter phone number to search');
    }
    else {
      this._commonService.searchByPhone(this.phoneNumber).subscribe((response: any) => {
        if (response.body.status == true) {
          var hasLatLong = false;
          if (response.body.data.latitude && response.body.data.longitude) {
            if (parseInt(response.body.data.latitude) > 0 && parseInt(response.body.data.longitude) > 0) {
              hasLatLong = true;
            }
          }
          if (hasLatLong == true) {
            response.body.data.longitude = parseFloat(response.body.data.longitude);
            response.body.data.latitude = parseFloat(response.body.data.latitude);
            this.phoneNumber = "";
            this.openDialog({ phoneNumber: this.phoneNumber, ...response.body.data });
          } else {
            if (response.body.data.address !== '' || response.body.data.address != null) {
              let address = response.body.data.buildingName + "," + response.body.data.buildingAddress;
              this._commonService.getGeoCodeByAddress(encodeURI(address)).subscribe((result: any) => {
                if (result.body.status == true) {
                  response.body.data.longitude = result.body.lng;
                  response.body.data.latitude = result.body.lat;
                  this.phoneNumber = "";
                  this.openDialog({ phoneNumber: this.phoneNumber, ...response.body.data });
                }
              });
            }
          }
        } else {
          if (response.body.code === '404')
            this._notificationService.basicMessage('Phone number not found.');
        }
      });
    }
  }
  // onFocus(event: any) {
  // }
  openDialog(data: any) {
    const dialogConfig = new MatDialogConfig();

    dialogConfig.disableClose = true;
    dialogConfig.autoFocus = true;
    dialogConfig.width = '565px';
    dialogConfig.height = '520px';
    dialogConfig.data = data;

    this._dialog.open(PhoneNumberSearchComponent, dialogConfig);
  }
  setLocalization(type: string) {   
    let countryId = Number.parseInt(this.selectedCountry);   
    if(isNaN(countryId))
    {
      countryId = this._localDataService.getLoginUserCountryId();
    }
    let selectedCountryShortName = this.countries.find(n => n.id == countryId)?.code;
    this._localDataService.selectedCountry = selectedCountryShortName;
    this._localDataService.selectedLanguage = this.selectedLanguage;
    
    ////this.localizationConfig(this._localDataService.selectedLanguage.slice(0, 2));
    this._localizationService.hub.currentLanguage = selectedCountryShortName + '_' + this.selectedLanguage;
     if (type === 'country') {
       this.languages = this._localDataService.getSelectedLanguages(countryId);
       this.selectedLanguage = 'eng';
       this._localizationService.use(selectedCountryShortName + '_' + this.selectedLanguage, [...Constants.Localization.commonAreas, ...this._localDataService.selectedScreen]);
     } else if (type === 'language') {
       this._localizationService.use(selectedCountryShortName + '_' + this.selectedLanguage, [...Constants.Localization.commonAreas, ...this._localDataService.selectedScreen]);
     } else if (type === 'screen') {
       this._localizationService.use(selectedCountryShortName + '_' + this.selectedLanguage, Constants.Localization.commonAreas);
     }
    this.updateLanguage(this.selectedLanguage);
   this.localCookies.set("selectedLanguage", this.selectedLanguage.toString());
   this.localCookies.set("selectedCountryId", countryId.toString());

   window.location.reload();   
  }
  
  updateLanguage(selectedLanguage: string) {
    //{"shortName":"fre","userId":"24","isAvaya":true}
    let payload = { "shortName": "", "userId": "", "isAvaya": false };
    payload.shortName = selectedLanguage;
    payload.isAvaya = (this._localDataService.getLoginUserRoleId() == 4 || this._localDataService.getLoginUserRoleId() == 5 || this._localDataService.getLoginUserRoleId() == 6 ? true : false)
    payload.userId = (payload.isAvaya ? this._cookieService.get(Constants.APPCOOKIES.AVAYA_USERID) : this._cookieService.get(Constants.APPCOOKIES.CCC_USERID))
    this._commonService.updateLanguage(payload).subscribe({
      next: (result: any) => {
        if (result.body.status) {
          if (result.body.langData) {
            if (result.body.langData.length > 1) {
              let shutdownReasonForAvaya: any = {};
              result.body.langData[1].forEach((sr: any) => {
                shutdownReasonForAvaya[sr.code] = sr.shutdownReason;
              });
              this._localDataService.shutdownReasonForAvaya = shutdownReasonForAvaya;
            }
          }
        }
      }, 
      error: (err: any) => { }
    })
  }
  public checkboxChange(value: boolean) {
    this.isChecked = value;
  }
   public async localizationConfig(setLang: string) {
      //await this.translationService.getLanguages();
      //await this.translationService.setCurrentLocale((setLang == null) ? 'en' : setLang).then(() => {
     }
  //      .catch(err => console.log(err));
  //  }
   /*
      * If Agent refresh the screen. If we are in screenpop or otislipbx. No need to get the user on refresh. It will show the same UI where Agent is.
    */
  ngOnInit(): void {
    //To check user status and available users count
    if (this.roleUserArray.includes(this._localDataService.getLoginUserRoleId().toString())) 
      this.userStatusDisplay = false;
    else if(this.userType == 1) 
      this.userStatusDisplay= true;

    this.loggedUserRoleId = this._localDataService.getLoginUserRoleId();
    this._twilioHelperService.agentStatusEmit.pipe(takeUntil(this.destroy$)).subscribe({
      next: (result: any) => {
        this.selectedAgentStatus = result;
      }
    });
    this._twilioHelperService.agentStatusCount.pipe(takeUntil(this.destroy$)).subscribe({
      next: (result: any) => {
        this.agentStatusCount = result;
      }
    });
    this.selectedCountry= this.localCookies.get('selectedCountryId');
    this.selectedLanguage= this.localCookies.get('selectedLanguage');
    if(!this.selectedLanguage)
    {
      this.selectedLanguage = 'eng';
    }
    let countryId = this._localDataService.getLoginUserCountryId();
    let languageShortName = this._localDataService.getLanguageShortName();
    //this.localizationConfig(languageShortName.slice(0, 2));
    let selectedCountryShortName = this.countries.find(n => n.id == countryId)?.code;
    if (!selectedCountryShortName) {
      selectedCountryShortName = 'US';
      //this._localizationService.hub.currentLanguage = 'US_' + languageShortName;
    }

    //this._screenpopService.languageString({page:this._localDataService.selectedCountry + "_" + this._localDataService.selectedLanguage + '_status.json'}).subscribe({
    //   this._screenpopService.languageString({page:'IN' + "_" + 'eng' + '_status.json'}).subscribe({
    //     next: (res: any) => {
    //       if (res.body.status) {
    //         this.statusTranslation = res.body;
    //       }
    //     }
    //  });

   this.statusjsondata=this._localDataService.getjasondata();

   //this.statusjsondata = 'src/assets/locale/IN_eng_status.json';
   this.url= 'src/assets/locale/IN_eng_status.json';
    //  this.http.get(this.url).subscribe(res => {
    //   this.statusjsondata = res;
    // });

    
    for (let modelItem of this.navData) {
      if (modelItem.text == 'dashboard')
        this.callElevatorButtonEnable = true;

      if (modelItem.text == 'callelevator')
      this.callElevatorButtonEnable = true;

      // if (modelItem.text == 'dashboard')
      //   this.phoneNumberButtonEnable = true;

      // // if (modelItem.text == 'EndOfAlarm')
      // //   this.endOfAlarmButtonEnable = true;

    }
    this._localDataService.selectedCountry = selectedCountryShortName;
    this._localDataService.selectedLanguage = this.selectedLanguage;
    this.screenWidth = window.innerWidth;
    // this._route.url.subscribe((url: any) => {
    //    this.setLocalization('screen');
    //    this.selectedScreen = url.splice(1);
    // });
    
  }
  getlaunagestringdata() {
    throw new Error('Method not implemented.');
  }
 
  getBodyClass(): string {
    let styleClass = '';
    if (this.collapsed && this.screenWidth > 768) {
      styleClass = 'body-trimmed';
    } else if (this.collapsed && this.screenWidth <= 768 && this.screenWidth > 0) {
      styleClass = 'body-md-screen'
    }
    return styleClass;
  }
  toggleCollapse(): void {
    this.expanded = !this.expanded;
    this.collapsed = !this.collapsed;
    this.onToggleSideNav.emit({ collapsed: this.collapsed, screenWidth: this.screenWidth });
  }
   closeSidenav(): void {
     this.collapsed = false;
     this.onToggleSideNav.emit({ collapsed: this.collapsed, screenWidth: this.screenWidth });
  }

  // // endOfAlarm() {
  // //   const loggedUser = this._localDataService.getLoginUserData();
  // //   this.elevatorCallService.getTPAStatus({
  // //     countryShortName: loggedUser['user']['countryShortName'],
  // //     elevatorId: this.eoaElevatorId.value
  // //   }).pipe(
  // //     map((resp:any) => {
  // //       if (resp.body.status) {
  // //           const dialogConfig = new MatDialogConfig();
  // //           dialogConfig.disableClose = true;
  // //           dialogConfig.autoFocus = true;
  // //           dialogConfig.width = '670px';
  // //           dialogConfig.height = '250px';
  // //           resp.body.elevatorId =  this.eoaElevatorId.value;
  // //           resp.body.countryShortName =  loggedUser['user']['countryShortName'];
  // //           dialogConfig.data = resp.body;
  // //           this.eoaElevatorId.setValue('');
  // //           this._dialog.open(EndOfAlarmComponent, dialogConfig);
  // //       }
  // //       if (resp.body?.err?.statusCode != 200) {
  // //         this._notificationService.toastMessage( this.errorCodes(resp.body), 'error');          
  // //       }
  // //     }),
  // //   ).subscribe();
  // // }

  handleClick(item: INavbarData): void {
    this.shrinkItems(item);
    item.expanded = !item.expanded
  }

  getActiveClass(data: INavbarData): string {
    return this._router.url.includes(data.link) ? 'active' : '';
  }

  shrinkItems(item: INavbarData): void {
    if (!this.multiple) {
      for (let modelItem of this.navData) {
        if (item !== modelItem && modelItem.expanded) {
          modelItem.expanded = false;
        }
      }
    }
  }

  logout(): void {
    if (this._localDataService.isCCCLoginUser() == 1) {
      //this._localDataService.clearLoginUserData();      
      this._twilioHelperService.logoutWorker(); 
      ////this._router.navigate(['/login']);
    }
    else {
      this._localDataService.clearLoginUserData();
      ////this._router.navigate(['/login']);
    }

  }

  aboutDialog() {
    this.openAboutDialog('about');
  }
  changePasswordDialog() {
    const dialogConfig = new MatDialogConfig();
    dialogConfig.disableClose = true;
    dialogConfig.autoFocus = true;
    dialogConfig.width = '670px';
    dialogConfig.height = '550px';
    dialogConfig.data = "";
    this._dialog.open(ChangePasswordComponent, dialogConfig);
  }

  openAboutDialog(data: any) {
    const dialogConfig = new MatDialogConfig();
    dialogConfig.disableClose = true;
    dialogConfig.autoFocus = true;
    dialogConfig.width = '670px';
    dialogConfig.height = '320px';
    dialogConfig.data = data;
    this._dialog.open(AboutComponent, dialogConfig);
  }

  // User Profile dialog
  userProfileDialog() {
    this.openUserProfileDialog('userProfile');
  }

  openUserProfileDialog(data: any) {
    const dialogConfig = new MatDialogConfig();
    dialogConfig.disableClose = true;
    dialogConfig.autoFocus = true;
    dialogConfig.width = '670px';
    dialogConfig.height = '480px';
    dialogConfig.data = data;
    this._dialog.open(UserProfileComponent, dialogConfig);
  }

  
  //call back from elevator
  elevatorCallBack(RIPriority?: boolean): void {
    let data = { elevatorId: this.elevatorId, riEnabled:RIPriority,displayElevatorId: this.elevatorId  };

    if(this._localDataService.isAvayaUser()){
      //  console.log(this._twilioHelperService.agentVideoTransmitEnable);
      if (this.elevatorId != null) {
        const dialogConfig = new MatDialogConfig();

        dialogConfig.disableClose = true;
        dialogConfig.autoFocus = true;
        dialogConfig.width = '400px';
        dialogConfig.height = '500px';
        dialogConfig.data = data;

        const dialogRef = this._dialog.open(CallElevatorComponent, dialogConfig);

        dialogRef.afterClosed().subscribe(result => {
          this.elevatorId = '';
        });
      } 
    } else {

      if (this.elevatorId != null) {
        const dialogConfig = new MatDialogConfig();

        dialogConfig.disableClose = true;
        dialogConfig.autoFocus = true;
        dialogConfig.width = '400px';
        dialogConfig.height = '500px';
        dialogConfig.data = data;

        const dialogRef = this._dialog.open(CallElevatorComponent, dialogConfig);

        dialogRef.afterClosed().subscribe(result => {
          this.elevatorId = '';
        });
      }
      // // this._twilioHelperService.callBackElevator(this.elevatorId,'','');
      // // this.elevatorId = '';
    }
  }
  ShowRIConfirmation() {
    //To show popup if it's RE & not avaya callback
    if(!this._localDataService.isAvayaUser() )
      {
        if(this._localDataService.ecd.currentUser.roleId == 7 && this._localDataService.ecd.currentUser.video == true){
            this._notificationService.deleteConfirmation(('deleteConfirmMsg'), 'Confirm' , () => {
              this.elevatorCallBack(true);
            });
        } else {
          this.elevatorCallBack(false);
        }
      } else {
        this.elevatorCallBack();
      }
  }
  errorCodes(res: any) {
      var error = ('unknownErr');
      switch (res.err.statusCode) {
        case 204:
          error = ('invalidElevatorId');
          break;
        case 400:
          error = ('deviceMayOffline');
          break;
        case 401:
          //Unauthorized from CIMS/G3MS
          error = ('unauthorized');
          break;
        case 404:
          //Not found
          error = res.err;
          break;
        case 503:
          //Error while process request with SQLServer from CIMS/G3MS
          error = ('sqlUnavailable');
          break;
        case 500:
          //Internal Server error thrown from CIMS/G3MS
          error = ('internalServerError');
          break;
        case 1000:
          //Invalid media region. This will be thrown, when callback, room is tried to created with invalid media region.
          error = ('invalidMediaRegion');
          break;
        case 1001:
          //Out of service unit
          error = "This unit is not under Otis Service. Unable to call the elevator";
          break;
      }

      return error;
    };
  changeAgentStatus(currentStatus: any, isFromModel: any, isUserRequest: boolean = false) {
      this._twilioHelperService.changeStatus(currentStatus,isFromModel, isUserRequest)
    }
  ngOnDestroy() {
      this.incomingCallStatus = { status: false, count: 0 };
      //  this._twilioHelperService.incomingCallNotification.complete();
      this.destroy$.next();
      this.destroy$.complete();
  }
    pageReloadData() {
      //after refresh we need to load latest menu data
      this.navData = this._localDataService.getMenuList();
  
      //To check user status and available users count
      if (this.roleUserArray?.includes(this._localDataService.getLoginUserRoleId().toString()))
        this.userStatusDisplay = false;
      else if (this.userType == 1)
        this.userStatusDisplay = true;
    }
}

